module.exports = __webpack_public_path__ + "static/wn-cutout-small-c1f947f17201de61242809877047b29a.png";